import React, { useState, useEffect } from 'react';
import '../CSS/LibraBanquetHall.css';
import venueImage from '../assets/ContactHeaderImg.jpeg';
import { FaUtensils, FaWifi, FaParking, FaUsers, FaMusic, FaCamera, FaStar, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import Contactbar from '../Components/ContactBar';

import libra1 from '../assets/LIBRA EVENTS/WhatsApp Image 2024-02-03 at 10.36.56 AM (1).jpeg';
import libra2 from '../assets/LIBRA EVENTS/_DSC9636.jpg';
import libra3 from '../assets/LIBRA EVENTS/_PHP0450.jpg';
import libra4 from '../assets/LIBRA EVENTS/1377.jpg';
import libra5 from '../assets/LIBRA EVENTS/1465.jpg';
import libra6 from '../assets/LIBRA EVENTS/KSH_0837.jpg';
import libra7 from '../assets/LIBRA EVENTS/KSH_2562.jpg';
import libra8 from '../assets/LIBRA EVENTS/KSH_9661.jpg';
import libra9 from '../assets/LIBRA EVENTS/KSH_7527.jpg';

const LibraBanquetHall = () => {

useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top on page load
  }, []);

    const [selectedImage, setSelectedImage] = useState(null);
const openModal = (img) => setSelectedImage(img);
const closeModal = () => setSelectedImage(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
 
  const handleSubmit = (e) => {
    e.preventDefault();
 
    const message = `*Venue Booking Request*\n\n*Name:* ${formData.name}\n*Email:* ${formData.email}\n*Phone:* ${formData.phone}\n*Message:* ${formData.message}`;
 
    const phoneNumber = '919909254684'; // 🔁 Replace with your WhatsApp number (with country code)
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
 
    window.open(url, '_blank');
 
    setShowModal(false); // Close modal
    setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
  };
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="libra-hero" style={{ backgroundImage: `url(${venueImage})` }}>
        <div className="libra-hero-overlay">
          <h1>LIBRA BANQUET HALL</h1>
          <p>Premium Venue for Unforgettable Celebrations</p>
        </div>
      </section>

      {/* About Section */}
      <section className="libra-content">
        <div className="libra-details">
          <h2>About the Venue</h2>
          <p>
Libra Banquet Hall is where your celebrations come to life in unparalleled style. Nestled conveniently in the heart of Vadodara, our venue offers a luxurious and sophisticated setting, perfect for everything from grand weddings and elegant receptions to impactful corporate events and cherished special occasions.
  <br/><br/>
We've meticulously designed Libra Banquet Hall to blend timeless elegance with modern comfort. Step inside and discover our spacious interiors, adorned with stunning décor and equipped with state-of-the-art lighting and sound systems. This creates the ideal ambiance for any event, ensuring your celebration is both vibrant and memorable.
  <br/><br/>
What truly sets us apart is our commitment to a seamless and stress-free experience. Our team of experienced event coordinators is dedicated to bringing your vision to life. They'll work closely with you, tailoring every detail to perfection, whether you're planning a lavish affair or an intimate gathering. Our versatile space can be effortlessly customized to suit your unique needs and preferences.
  <br/><br/>
Beyond the beautiful setting, we offer exceptional catering services with a diverse range of culinary delights, ample parking for your guests' convenience, and a warm, welcoming atmosphere that makes everyone feel at ease.
  <br/><br/>
At Libra Banquet Hall, we don't just host events; we craft unforgettable memories. We handle the intricacies, so you can focus on savoring every precious moment. We invite you to visit us and discover how we can transform your ideas into a truly spectacular reality.

</p>
          

          <h3>Key Features</h3>
          <div className="libra-features">
            <div className="libra-feature-item"><FaUsers className="icon" /> 1000 Guest Capacity</div>
            <div className="libra-feature-item"><FaParking className="icon" /> Standard Parking</div>
            <div className="libra-feature-item"><FaWifi className="icon" /> High-Speed WiFi</div>
            <div className="libra-feature-item"><FaUtensils className="icon" /> Premium Catering</div>
            <div className="libra-feature-item"><FaMusic className="icon" /> Sound System</div>
            <div className="libra-feature-item"><FaCamera className="icon" /> Photo Zones</div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
<section className="libra-gallery">
  <h2>Venue Gallery</h2>
  <div className="gallery-grid">
    {[
      libra1,libra2,libra3,libra4,libra5,libra6,libra7,libra8,libra9
    ].map((img, index) => (
      <div key={index} className="gallery-item">
        <img src={img} alt={`Gallery ${index + 1}`} onClick={() => openModal(img)} />
      </div>
    ))}
  </div>

  {/* Modal */}
  {selectedImage && (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={selectedImage} alt="Zoomed" />
        <span className="modal-close" onClick={closeModal}>&times;</span>
      </div>
    </div>
  )}
</section>

      {/* Event Types Section */}
      <section className="libra-events">
        <h2>Perfect For All Occasions</h2>
        <div className="event-types">
          <div><FaCalendarAlt /> Weddings</div>
          <div><FaCalendarAlt /> Engagements</div>
          <div><FaCalendarAlt /> Corporate Seminars</div>
          <div><FaCalendarAlt /> Birthday Parties</div>
          <div><FaCalendarAlt /> Anniversary Celebrations</div>
        </div>
      </section>

      {/* Amenities Section */}
      <section className="libra-amenities">
        <h2>Amenities</h2>
        <ul className="amenities-list">
            <li>Air-conditioned Hall</li>
            <li>Standard Parking</li>
            <li>High-Speed Wi-Fi</li>
            <li>Stage and Lighting</li>
            <li>On-Site Catering</li>
            <li>Changing Rooms</li>
            <li>Backup Power Supply</li>
            <li>Audio Visual Equipment</li>
            <li>Dedicated Event Manager</li>
            <li>Security Staff</li>
            <li>Luxury Washrooms</li>
            <li>Photobooth Area</li>
        </ul>
    </section>


      {/* Why Choose Us */}
      <section className="libra-why-choose">
        <h2>Why Choose Libra Banquet Hall ?</h2>
        <p>
           With our blend of luxury, service, and technology, we offer a truly premium experience. Our team ensures that every event is stress-free,
  beautifully executed, and memorable for both hosts and guests.
  <br/><br/>
  From personalized décor themes to gourmet catering, we tailor every detail to match your vision and style. Our staff is trained to deliver impeccable hospitality,
  making sure your guests feel welcomed and cared for throughout the event.
  <br/><br/>
  With ample parking space, flexible seating arrangements, and cutting-edge facilities, we go above and beyond to create an unforgettable experience
  that exceeds expectations.
        </p>
        <div className="reasons">
          <div><FaStar /> Trusted by Thousands of Clients</div>
          <div><FaStar /> Centrally Located</div>
          <div><FaStar /> Highly Rated Service</div>
          <div><FaStar /> Tailored Packages Available</div>
        </div>
      </section>

      {/* Map/Location (optional image placeholder) */}
      <section className="libra-map">
        <h2>Our Location</h2>
        <div className="map-placeholder">
          <FaMapMarkerAlt className="map-icon" />
          <p> Basement, 2, Eva Mall Rd,
      near Saraswati Complex, <br/>
      Patidar Crossing, Manjalpur, 
      Vadodara, Gujarat 390011</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3692.151311369257!2d73.1877681!3d22.2722574!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc572a56acfcd%3A0x27bab60c571357df!2sLibra%20Events%20%26%20Decorators!5e0!3m2!1sen!2sin!4v1755498578380!5m2!1sen!2sin"width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"
                ></iframe>
        </div>
      </section>

      {/* Booking CTA */}
<div className="libra-cta-wrapper">
  <section className="libra-booking-cta">
    <h2>Ready to Book Your Event ?</h2>
    <p>Make your celebration unforgettable at Libra Banquet Hall. Contact us now to check availability and receive a customized quote for your special occasion.</p>
    <div className="cta-buttons">
      <button className="book-now" onClick={() => setShowModal(true)}>Book Now</button>
      <a href="/venues" className="contact">Back to Venues</a>
    </div>
  </section>
</div>

{/* Modal Section */}
      {showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <h3>Book Now</h3>
      <form className="modal-form" onSubmit={(e) => handleSubmit(e)}>
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          required
        />
        <input
          type="tel"
          placeholder="Your Phone"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          required
        />
        <textarea
          placeholder="Message / Special Requests"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        ></textarea>
        <div className="modal-actions">
          <button type="submit" className="submit-btn">Send</button>
          <button type="button" className="close-btn" onClick={() => setShowModal(false)}>Close</button>
        </div>
      </form>
    </div>
  </div>
)}

<Contactbar/>
      <Footer />
    </>
  );
};

export default LibraBanquetHall;
